import React, { type FC } from 'react'

import { useRecoilCallback } from 'recoil'

import { Link } from 'mailup-web-components'

import { panelEditRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

import GroupsView from 'Pages/RecipientsList/components/results/GroupsView'

interface ItemGroupsProps {
  id: number
  isMainItem?: boolean
}

const ItemGroups: FC<ItemGroupsProps> = ({ id, isMainItem }) => {
  const panelOpen = useRecoilCallback(panelEditRecipientOpenCallback, [])

  const handleClick = (e: React.MouseEvent<HTMLLinkElement>): void => {
    e.stopPropagation()

    void panelOpen(id)
  }

  if (isMainItem === true) {
    return (
      <Link onClick={handleClick} data-mu-test="item-engagement">
        <GroupsView id={id} />
      </Link>
    )
  }

  return <GroupsView id={id} />
}

export default ItemGroups
